<template>
  <b-container v-if="path || isEmbed">
    <prismic-rich-text
      v-if="title"
      :field="title"
      class="title"
      :class="textsAlignClass"
    ></prismic-rich-text>
    <prismic-rich-text
      v-if="subtitle"
      :field="subtitle"
      class="title video-subtitle"
      :class="textsAlignClass"
    ></prismic-rich-text>
    <Video :width="width" :path="path" :options="options" />
  </b-container>
</template>

<script>
import Video from '@/components/Common/Video.vue';

export default {
  components: {
    Video
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      path: '',
      title: '',
      subtitle: '',
      textsAlign: '',
      width: 1114,
      options: {}
    };
  },
  computed: {
    textsAlignClass() {
      let result = '';

      if (this.textsAlign === 'center') {
        result = 'text-center';
      } else if (this.textsAlign === 'right') {
        result = 'text-right';
      } else {
        result = 'text-left';
      }

      return result;
    }
  },
  created() {
    const sizes = [
      { key: 'medium', width: 900 },
      { key: 'small', width: 701 },
      { key: 'smallest', width: 500 }
    ];
    this.path = this.slice.primary.path ? this.slice.primary.path : '';
    this.title = this.slice.primary.title1[0]?.text ? this.slice.primary.title1 : '';
    this.subtitle = this.slice.primary.subtitle[0]?.text ? this.slice.primary.subtitle : '';
    this.textsAlign = this.slice.primary.texts_align;
    this.isEmbed = this.slice.primary?.is_embed;
    const sizeSelected = this.slice.primary.size;
    if (sizeSelected) {
      const sizeFound = sizes.filter((size) => size.key === sizeSelected);
      if (sizeFound.length) {
        this.width = sizeFound[0].width;
      }
    }
    if (this.isEmbed) {
      this.options = {
        language: 'en',
        playbackRates: [1.0],
        sources: [
          {
            type: 'video/mp4',
            src: this.path
          }
        ],
        poster: this.slice.primary.poster ? this.slice.primary.poster : ''
      };
      this.path = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: left;
  font-size: 2em;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  padding-bottom: 20px;
}
.video-subtitle {
  font-size: 1.5em;
}
</style>
